<div
    [class]="setStyleFlag() ? 'bg-primary' : 'bg-white'"
    class="relative px-4 py-3 flex w-full justify-between gap-2.5 rounded-xl"
>
    @if (!completenessError()) {
        @if (open1()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open1.set(false)"
                class="absolute bottom-[calc(100%+12px)]"
            >
                서비스를 부여할 아동을 선택해주세요
            </app-chat-tooltip>
        }

        @if (open2()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open1.set(false)"
                class="absolute bottom-[calc(100%+12px)]"
            >
                '서비스' 탭을 선택해주세요
            </app-chat-tooltip>
        }

        @if (open3()) {
            <app-chat-tooltip
                animate.leave="fade-out"
                (close)="open1.set(false)"
                class="absolute bottom-[calc(100%+12px)]"
            >
                오른쪽 상단에 파란색 '서비스 등록'을 선택해주세요
            </app-chat-tooltip>
        }
    }

    @if ((!open1() || !open2() || !open3()) && completenessError() === "3") {
        <app-chat-tooltip
            disableClose
            animate.leave="fade-out"
            class="absolute bottom-[calc(100%+12px)]"
        >
            서비스를 먼저 등록해주세요
        </app-chat-tooltip>
    }

    <div class="flex gap-2.5 items-center">
        <p
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-800'"
            [class.!text-gray-400]="completeness()?.childWithService"
            class="lg:text-base text-sm"
        >
            서비스 부여
        </p>

        @if (!completeness()?.childWithService) {
            <div
                [class]="
                    setStyleFlag()
                        ? 'bg-white !text-gray-800'
                        : 'text-white bg-primary'
                "
                class="badge"
            >
                등록 필요
            </div>
        } @else {
            <div class="badge bg-gray-400">완료</div>
        }
    </div>

    <div routerLink="/child" class="flex gap-2 items-center cursor-pointer">
        <p
            [class]="setStyleFlag() ? 'text-white' : 'text-gray-400 '"
            class="text-sm lg:block hidden"
        >
            @if (completeness()?.childWithService) {
                등록완료
            } @else {
                등록하기
            }
        </p>
        <app-icon
            name="material-symbols:arrow-forward-ios"
            class="!size-3.5 text-gray-300"
        />
    </div>
</div>
